import React, { useRef } from "react";
import { Button, ButtonGroup, Flex, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import {
  TiSocialLinkedinCircular,
  TiSocialGithubCircular,
  TiMail,
  TiSocialInstagramCircular
} from "react-icons/ti";



export default function Contact() {
  return (
    <div id="contact">
      <Flex
        justifyContent={"center"}
        alignItems="center"
        flexDir="column"
        my="5rem"
        gap="5rem"
      >
         <Flex
         flexDir="column"
          justifyContent={"center"}
          alignItems={"center"}
          borderRadius="1rem"
          background="offwhiteOpacity"
          backdropFilter="blur(5px)"
          border="lightgrey solid 1px"
          gap="1rem"
          py="2rem"
          px="5rem"
        >
          <Text variant={"subHeader"} color="lightblue">
            Contact Me!
          </Text>
          <Link to="mailto:jessica_wan@alumni.brown.edu">
            <Button
              variant="outline"
              px="3rem"
              color="lightblue"
              borderColor="lightblue"
              _hover={{ borderColor: "black", color: "black" }}
              gap=".5rem"
            >
              <TiMail size="1rem" />
              email
            </Button>
          </Link>
          <Link to="https://www.linkedin.com/in/jessicawan02/" target="_blank">
            <Button
              variant="outline"
              px="3rem"
              color="lightblue"
              borderColor="lightblue"
              _hover={{ borderColor: "black", color: "black" }}
              gap=".5rem"
            >
              <TiSocialLinkedinCircular size="1rem" />
              LinkedIn
            </Button>
          </Link>
          <Link to="https://github.com/jjesswan" target="_blank">
            <Button
              variant="outline"
              px="3rem"
              color="lightblue"
              borderColor="lightblue"
              _hover={{ borderColor: "black", color: "black" }}
              gap=".5rem"
            >
              <TiSocialGithubCircular size="1rem" />
              Github
            </Button>
          </Link>
           <Link to="https://www.instagram.com/jjessiart/" target="_blank">
            <Button
              variant="outline"
              px="3rem"
              color="lightblue"
              borderColor="lightblue"
              _hover={{ borderColor: "black", color: "black" }}
              gap=".5rem"
            >
              <TiSocialInstagramCircular size="1rem" />
              Instagram
            </Button>
          </Link>
        </Flex>
        <Flex>
          <Text variant="typeItalic" align="center" color="black">
            Designed and Developed with ❤ by Jessica <br></br>© Copyright 2025
          </Text>
        </Flex>
      </Flex>
    </div>
  );
}
